const mEditionAssetInvitations = {
  mEditionAssetInvitations: {
    alerts: {
      reenviarInvitacionPendiente: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'Se reenvió de forma exitosa la invitación.'
      }
    },

    buttonIconRounded: {
      dataTooltip: 'Ver Datos',
      linkTooltip: 'Copiar Url',
      resendTooltip: 'Reenviar'
    },

    buttonSecondary: {
      createText: 'Enviar Invitación',
      filterText: 'Filtros Avanzados',
      reloadTooltip: 'Actualizar'
    },

    input: {
      email: {
        placeholder: 'usuario@email.com'
      }
    },

    table: {
      thData: 'Datos',
      thDate: 'Fecha de Envío',
      thDateVenc: 'Fecha de Venc.',
      thEmail: 'Email',
      thResend: 'Reenviar',
      thRoles: 'Roles',
      thUrl: 'Url'
    }
  }
}

export default mEditionAssetInvitations
